import { InjectionToken } from "@angular/core";
import { ICreateLauncherModalService } from "./i-create-launcher-modal.service";

export const createLauncherModalServiceInjectionToken: InjectionToken<ICreateLauncherModalService> = new InjectionToken("digital-signage.developer-dashboard.dashboard-web.CreateLauncherModalService");
